// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--X9dhn";
export var campanyName = "footer-module--campanyName--3U8Wf";
export var copyright = "footer-module--copyright--3q9Mj";